<template>
<el-dialog v-model="visible" title="查看详情" :before-close="close" custom-class="text-report-detail-dialog">
  <div class="trdd-body" v-loading="loading">
    <template v-if="Object.keys(dialogData).length > 0">
      <div class="body-title">{{dialogData.baseInfo.txtClinicName}} 检测报告单</div>
      <div class="body-base-info">
        <div class="common-title bbi-title">基本信息</div>
        <table>
          <tr>
            <td>姓名：{{detailData.txtUsername || "- -"}}</td>
            <td>性别：{{detailData.txtGender || "- -"}}</td>
            <td>年龄：
              <template v-if="detailData.intAge==0">{{ detailData.intAge }}</template>
              <template v-else>{{detailData.intAge || "- -"}}</template>
            </td>
            <td>联系方式：{{detailData.txtMobile || "- -"}}</td>
          </tr>
          <tr>
            <td colspan="2">检测项目：{{detailData.txtTpName}}</td>
            <td colspan="2">采集时间：{{dialogData.baseInfo.dtGather || "- -"}}</td>
          </tr>
        </table>
      </div>
      <div class="test-detail-part">
        <div class="common-title test-title">{{ dialogData.baseInfo.txtTpName}}</div>
        <template v-if="dialogData.all">
          <div class="tdp-wbc-part">
            <div class="tdp-wbc-pt-title-line row-center-between">
              <div>项目：{{ dialogData.all.txtTpName }}</div>
              <div>检测时间：{{ dialogData.all.dtDetect || "- -" }}</div>
            </div>
            <table>
              <tr>
                <th>参数</th>
                <th>结果</th>
                <th>参考区间</th>
                <th v-if="detailData.deviceTypeCode=='LXCVWBC'">单位</th>
              </tr>
              <tr v-for="(item, index) in dialogData.all.results" :key="index" v-show="item.printable">
                <td :class="item.boldFlag?'text-bold':''" v-if="detailData.deviceTypeCode=='LXCVWBC'">
                  <div>{{ item.txtItemCode }}</div>
                  <div>({{ item.txtItemName }})</div>
                </td>
                <td class="text-bold" v-else>
                  <div>{{ item.txtItemCode }}</div>
                  <div>({{ item.txtItemName }})</div>
                </td>
                <td class="text-bold" :class="item.txtResult=='L'?'text-red':item.txtResult=='H'?'text-green':''">{{ item.txtValue || "- -" }}</td>
                <td>{{ item.txtRange }}</td>
                <td v-if="detailData.deviceTypeCode=='LXCVWBC'">{{ item.txtUnit }}</td>
              </tr>
            </table>
            <!-- 渲染图 -->
            <div class="tdp-p-chart-part" v-if="allChartShow">
              <div v-if="chartShow.WBC" class="tdp-p-line-chart" id="wbcChart"></div>
              <div v-if="chartShow.RBC" class="tdp-p-line-chart" id="rbcChart"></div>
              <div v-if="chartShow.PLT" class="tdp-p-line-chart" id="pltChart"></div>
            </div>
          </div>
        </template>
        <template v-if="dialogData.cg">
          <div class="tdp-item" v-for="(item, index) in dialogData.cg" :key="index">
            <table>
              <tr>
                <th>项目：{{ item.txtCategoryName || "- -" }}（{{ item.txtCategoryDesc }}）</th>
                <th></th>
                <th>
                  <div v-if="item.txtCategoryTitle1">{{item.txtCategoryTitle1}}：{{item.txtDetectResult1}}</div>
                  <div v-if="item.txtCategoryTitle2">{{item.txtCategoryTitle2}}：{{item.txtDetectResult2}}</div>
                </th>
                <th>结果：{{ item.txtResultValue }}</th>
              </tr>
              <tr>
                <td colspan="2">参考区间：{{item.txtValueRange||"- -"}}</td>
                <td colspan="2">检测时间：{{item.dtDetect}}</td>
              </tr>
            </table>
            <div class="tdp-progress">
              <div class="tdp-result" id="tdp-result1" :style="{marginLeft: compWidth(item.txtParamsRange1, item.fltDetectResult1, 'pointerLine_1')}">{{ item.txtCategoryTitle1 }}： {{item.txtDetectResult1}}</div>
              <div class="tdpp-line row-center-center">
                <img src="../../../assets/imgs/pointer.png" :style="{left: compWidth(item.txtParamsRange1, item.fltDetectResult1, 'pointer')}">
                <div class="tdpp-progress-line"></div>
              </div>
              <div class="tdpp-line-num row-center-start">
                <div v-for="(sItem, sIndex) in item.txtParamsRange1.split('/')" :key="sIndex" :class="sIndex > 1 ? 'absoPosition': ''" :style="[{width: sIndex == 0 ? compWidth(item.txtParamsRange1, item.fltDetectResult1, sIndex) : ''}, {left: (sIndex > 1 && sIndex < item.txtParamsRange1.split('/').length-1) ? compWidth(item.txtParamsRange1, item.fltDetectResult1, sIndex) : ''}]">{{ sItem }}</div>
              </div>
            </div>
            <div class="tdp-progress" v-if="(item.txtParamsRange2||'') != ''">
              <div class="tdp-result" id="tdp-result2" :style="{marginLeft: compWidth(item.txtParamsRange2, item.fltDetectResult2, 'pointerLine_2')}">{{ item.txtCategoryTitle2 }}： {{item.txtDetectResult2}}</div>
              <div class="tdpp-line row-center-center">
                <img src="../../../assets/imgs/pointer.png" :style="{left: compWidth(item.txtParamsRange2, item.fltDetectResult2, 'pointer')}">
                <div class="tdpp-progress-line"></div>
              </div>
              <div class="tdpp-line-num row-center-start">
                <div v-for="(sItem, sIndex) in item.txtParamsRange2.split('/')" :key="sIndex" :class="sIndex > 1 ? 'absoPosition': ''" :style="[{width: sIndex == 0 ? compWidth(item.txtParamsRange2, item.fltDetectResult2, sIndex) : ''}, {left: (sIndex > 1 && sIndex < item.txtParamsRange1.split('/').length-1) ? compWidth(item.txtParamsRange2, item.fltDetectResult2, sIndex) : ''}]">{{ sItem }}</div>
              </div>
            </div>
            <div class="tdp-pro-unscramble">
              <div>项目解读：</div>
              <div>{{item.txtCategoryInterpreted}}</div>
            </div>
            <div class="tdp-pro-unscramble">
              <div>智能解析：</div>
              <div>{{item.txtResultAnalysis}}</div>
            </div>
          </div>
        </template>
      </div>
      <div class="user-textarea-part">
        <div class="common-title utp-title">
          病人主诉
          <el-button type="primary" size="small" @click="dialogData.baseInfo.txtPatientDescription=null">清空</el-button>
        </div>
        <el-input v-model="dialogData.baseInfo.txtPatientDescription" maxlength="400" show-word-limit :rows="3" type="textarea" placeholder="请填写患者本次就诊的主要症状（或体征）、持续时间等" />
      </div>
      <div class="user-textarea-part">
        <div class="common-title utp-title">
          医嘱建议
          <el-button type="primary" size="small" @click="dialogData.baseInfo.txtDoctorSuggestion=null">清空</el-button>
        </div>
        <el-input v-model="dialogData.baseInfo.txtDoctorSuggestion" maxlength="400" show-word-limit :rows="3" type="textarea" placeholder="请填写病人在饮食、用药、化验等方面的指示" />
      </div>
      <div class="user-textarea-part row-center-start">
        <div class="common-title utp-title no-margin">医生签字</div>
        <el-input class="doctor-input" clearable v-model="dialogData.baseInfo.txtDoctorSignature" minlength="2" maxlength="10" placeholder="请填写医生姓名" />
        <div class="input-hint" v-if="hintShow">最少输入两个字符</div>
      </div>
    </template>
    <div v-else class="no-data column-center-center">暂无数据</div>
  </div>
  <template #footer v-if="Object.keys(dialogData).length > 0">
    <div class="dialog-footer">
      <el-button type="info" @click="close()">取 消</el-button>
      <el-button type="primary" @click="handleSubmit()" v-preventReClick>确 定</el-button>
    </div>
  </template>
</el-dialog>
</template>

<script>
import { ElMessage } from "element-plus";
import { getOrderDetailById, updateCase } from "api/apis.js";
import { onMounted, reactive, toRefs, inject, computed } from 'vue';
export default {
  props: {
    detailData: { type: Object }
  },
  setup(prop, ctx) {
    // 引入echarts
    let echart = inject("echart");
    const state = reactive({
      visible: true,
      loading: false,
      dialogData: {},
      hintShow: false,
      chartData: {
        WBC: null,
        RBC: null,
        PLT: null
      },
      chartShow: {
        WBC: true,
        RBC: true,
        PLT: true
      },
      // 有一个为true就显示
      allChartShow: computed(() => state.chartShow.WBC || state.chartShow.RBC || state.chartShow.PLT)
    });

    onMounted(() => {
      getDetailData();
    })

    // 保存
    const handleSubmit = () => {
      if ((state.dialogData.baseInfo.txtDoctorSignature || "").trim() != "") {
        if (state.dialogData.baseInfo.txtDoctorSignature.length < 2) {
          state.hintShow = true;
        } else {
          state.hintShow = false;
        }
      }
      if (state.hintShow == false) {
        state.loading = true;
        updateCase({
          orderId: prop.detailData.orderId,
          deviceTypeCode: prop.detailData.deviceTypeCode,
          txtPatientDescription: state.dialogData.baseInfo.txtPatientDescription,
          txtDoctorSuggestion: state.dialogData.baseInfo.txtDoctorSuggestion,
          txtDoctorSignature: state.dialogData.baseInfo.txtDoctorSignature
        }).then(response => {
          if (response.code == 200) {
            ElMessage.success("保存成功");
            close();
          } else {
            ElMessage.error(response.message);
          }
        }).catch(e => {
          console.error(e);
        }).finally(() => {
          state.loading = false;
        })
      }
    };

    // 获取详细信息
    const getDetailData = () => {
      state.loading = true;
      getOrderDetailById({
        orderId: prop.detailData.orderId,
        // orderId: 914,
        deviceTypeCode: prop.detailData.deviceTypeCode
      }).then(response => {
        if (response.code == 200) {
          state.dialogData.baseInfo = response.data.baseInfo;

          // 如果是 血细胞
          if (prop.detailData.deviceTypeCode == "LXCG") {
            // 赋值
            state.dialogData = response.data;
          } else {
            state.dialogData.all = response.data.wbc || response.data.cvwbc;
            state.dialogData.cg = response.data.cg || [];

            // 格式化数据，渲染图表
            setTimeout(() => {
              formatData();
            }, 500)
          }

          // state.dialogData.all.pltHist = [];
          // state.dialogData.all.rbcHist = [];
          // state.dialogData.all.wbcHist = [];

        } else {
          state.dialogData = {};
          ElMessage.error(response.message);
        }
      }).catch(e => {
        console.error(e);
      }).finally(() => {
        state.loading = false;
      })
    };

    // 动态计算高度
    const compWidth = (result, detect, type) => {
      let tempResult = result.split("/"),
        end = parseFloat(tempResult[tempResult.length - 1]);
      if (typeof type == "string") {
        let pointer = parseFloat(detect);
        // 超过 50%，橘色条 显示在左边，防止右侧 UI 溢出
        let marginLeft = (Math.round(pointer / end * 10000) / 100.00);
        // 如果 值 > 100, 则改为 100， 防止位置过界（在视角之外）
        if (marginLeft > 100) {
          marginLeft = 100;
        }

        if (type == "pointer") {
          if (marginLeft == 100) {
            return "calc(" + parseFloat(marginLeft) + "% - 18px)";
          } else {
            return marginLeft + "%";
          }
        }

        if (marginLeft > 50 && type.includes("pointerLine")) {
          let key = type.split("_")[1],
            orange = document.getElementById("tdp-result" + key);
          if (orange) {
            orange = orange.offsetWidth - 16;
          } else {
            orange = 0;
          }

          return "calc(" + parseFloat(marginLeft) + "% - " + orange + "px)";
        } else {
          return marginLeft + "%";
        }
      } else {
        // 不管长度为多少，除 0 以外 第一个数，都这样计算
        let width = Math.round(tempResult[1] / end * 10000) / 100.00;
        if (type == 0) {
          return width + "%";
        }
        // 判断 区间长度
        // 如果三位数
        if (tempResult.length == 3) {
          if (type == 1) {
            return (100 - width) + "%";
          }
        } else {
          let left = Math.round(tempResult[type] / end * 10000) / 100.00;
          return left + "%";
        }
      }
    };

    // 格式化数据
    const formatData = () => {
      let myChart, chartId;
      // 半自动血细胞分析仪
      if (prop.detailData.deviceTypeCode == 'LXEIWBC') {
        state.chartShow = {
          RBC: false,
          PLT: false
        };
        // 存在图表
        if ((state.dialogData.all.histInfo.hist || []).length > 0) {
          state.chartShow.WBC = true;
          chartId = "wbcChart";
          document.getElementById(chartId).style.width = "100%";
          echart.init(document.getElementById(chartId)).dispose();
          myChart = echart.init(document.getElementById(chartId));
          state.chartData.WBC = state.dialogData.all.histInfo;
          initChart(chartId, myChart);
        } else {
          state.chartShow.WBC = false;
          state.chartData.WBC = null;
        }
      } else {
        // 全自动血细胞分析仪
        let sourceData = [(state.dialogData.all.wbcHist || []), (state.dialogData.all.rbcHist || []), (state.dialogData.all.pltHist || [])],
          length = 0; // 用来标定 图表数量，方便设置宽度
        for (let i = 0; i < sourceData.length; i++) {
          if (sourceData[i].length > 0) {
            length += 1;
          }
        }

        if (length != 0) {
          for (let i = 0; i < length; i++) {
            document.getElementsByClassName("tdp-p-line-chart")[i].style.width = 100 / length + "%";
          }
        }

        // wbc 部分
        if ((state.dialogData.all.wbcHist || []).length > 0) {
          state.chartShow.WBC = true;
          chartId = "wbcChart";
          echart.init(document.getElementById(chartId)).dispose();
          myChart = echart.init(document.getElementById(chartId));
          state.chartData.WBC = state.dialogData.all.wbcHist;
          initChart(chartId, myChart);
        } else {
          state.chartShow.WBC = false;
          state.chartData.WBC = null;
        }
        // RBC 部分
        if ((state.dialogData.all.rbcHist || []).length > 0) {
          state.chartShow.RBC = true;
          chartId = "rbcChart";
          echart.init(document.getElementById(chartId)).dispose();
          myChart = echart.init(document.getElementById(chartId));
          state.chartData.RBC = state.dialogData.all.rbcHist;
          initChart(chartId, myChart);
        } else {
          state.chartShow.RBC = false;
          state.chartData.RBC = null;
        }
        // PLT 部分
        if ((state.dialogData.all.pltHist || []).length > 0) {
          state.chartShow.PLT = true;
          chartId = "pltChart";
          echart.init(document.getElementById(chartId)).dispose();
          myChart = echart.init(document.getElementById(chartId));
          state.chartData.PLT = state.dialogData.all.pltHist;
          initChart(chartId, myChart);
        } else {
          state.chartShow.PLT = false;
          state.chartData.PLT = null;
        }
      }
    };

    // 渲染图表
    const initChart = (chartId, myChart) => {
      let key = chartId.split("Chart")[0].toLocaleUpperCase(),
        // 所有默认配置都是 全自动血细胞 WBC 的样式
        // 需按条件单独修改
        data = state.chartData[key], // series data
        markLine = { show: false }, // 横坐标 标识线
        axisName = "fL", // 横坐标 名称
        axisLabel = { show: true }, // 横坐标 刻度
        areaColor = "#bbbbbb", // 区域颜色
        yAxis = { type: 'value', show: true, axisTick: { show: false }, axisLabel: { show: false } }, // 纵坐标
        title = { show: true, left: 'center', textStyle: { color: "#333333", fontWeight: "bold", fontSize: 16 } }, // 标题
        grid = { left: "4%", right: "10%", top: "14%", bottom: "14%" }, // 图表布局
        lineStyle = { color: "#606060" }; // 线的配置

      // 如果是半自动血细胞 单独配置
      if (prop.detailData.deviceTypeCode == 'LXEIWBC') {
        data = state.chartData[key].hist;
        grid.bottom = "4%";
        grid.right = "4%";
        // 横坐标 标识线
        markLine = {
          symbol: ['none', 'none'],
          label: { show: false },
          emphasis: { disabled: true },
          lineStyle: { color: "#9fa9a8" },
          data: [{ xAxis: state.chartData[key].lymEndIndex }, { xAxis: state.chartData[key].midEndIndex }]
        };
        // 横坐标 名称
        axisName = "";
        // 横坐标 刻度
        axisLabel = { show: false };
        // 区域颜色
        areaColor = "#c5d8d8";
        // 纵坐标
        yAxis = { type: 'value', show: false };
        // 标题
        title = { show: false };
        // 线的配置
        lineStyle = { color: "#a6abac" };
      } else {
        // title 赋值
        title.text = key;
        if (key == "RBC") {
          areaColor = "#f56c6c"; // 区域颜色
          lineStyle = { color: "#f56c6c" }; // 线的配置
        } else if (key == "PLT") {
          areaColor = "#9ad67c"; // 区域颜色
          lineStyle = { color: "#9ad67c" }; // 线的配置
        }
      }

      // 配置图表
      myChart.setOption({
        title,
        grid,
        xAxis: {
          type: 'category',
          name: axisName,
          axisTick: { show: false },
          axisLabel: axisLabel,
          axisLine: { lineStyle: { color: "#7d8687" } }
        },
        yAxis,
        series: [{
          type: 'line',
          smooth: 0.6,
          symbol: 'circle',
          emphasis: { disabled: true },
          markLine,
          areaStyle: { color: areaColor },
          lineStyle,
          data: data.map(t => { return { value: t, name: "" } })
        }]
      })
    };

    // dialog 关闭事件
    const close = () => {
      ctx.emit("close");
    };

    return {
      ...toRefs(state),
      close,
      compWidth,
      getDetailData,
      handleSubmit,
      initChart,
      formatData,
    }
  }
}
</script>

<style lang="scss">
.text-report-detail-dialog {
  width: 900px;
  height: calc(100% - 25vh);

  .el-dialog__header {
    font-weight: bold;
  }

  .el-dialog__body {
    padding: 15px 20px;
    height: calc(100% - 120px);
    box-sizing: border-box;

    .no-data {
      height: 100%;
      width: 100%;
    }

    .trdd-body {
      height: 100%;

      .common-title {
        font-size: 16px;
        font-weight: bold;

        .el-button {
          margin-left: 4px;
        }
      }

      .body-title {
        font-size: 20px;
        font-weight: bold;
        text-align: center;
      }

      .body-base-info {
        margin-top: 6px;

        table {
          margin: 6px 0;
          padding: 6px 6px;
          border-top: 1px solid #f6f3ef;
          border-bottom: 1px solid #f6f3ef;
          width: 100%;

          tr {
            td {
              padding: 8px 0;
              width: calc(100% / 4);
              letter-spacing: 1px;
            }
          }
        }
      }

      .test-detail-part {
        .test-title {
          text-align: center;
          margin: 12px 0 8px 0;
        }

        .tdp-wbc-part {
          margin: 6px 0;
          padding: 6px 6px;
          width: 100%;
          box-sizing: border-box;

          .tdp-p-chart-part {
            height: 150px;
            display: flex;
            flex-direction: row;
            align-items: center;

            .tdp-p-line-chart {
              height: 100%;
            }
          }

          .tdp-wbc-pt-title-line {
            padding: 6px 6px;

            div {
              &:first-child {
                font-weight: bold
              }
            }
          }

          table {
            margin: 6px 0;
            width: 100%;

            tr {
              th {
                color: #ffffff;
                padding: 8px 0;
                width: 28%;
                background-color: #70bffe;
              }

              td {
                text-align: center;
                padding: 8px 0;
                background-color: #daeeff;

                &.text-bold {
                  font-weight: bold;
                }

                &.text-red {
                  color: #ff0000;
                }

                &.text-green {
                  color: #67c23a;
                }

                div {
                  &:last-child {
                    font-weight: 400;
                    color: #b1b3b8;
                  }
                }
              }
            }
          }
        }

        .tdp-item {
          padding-bottom: 26px;
          border-bottom: 1px solid #f6f3ef;

          table {
            margin: 6px 0;
            padding: 6px 6px;
            width: 100%;
            table-layout: fixed;

            tr {

              th,
              td {
                padding: 4px 0;
                width: calc(100% / 4);
                letter-spacing: 1px;
                text-align: left;
              }
            }
          }

          .tdp-progress {
            .tdp-result {
              color: #ffffff;
              padding: 4px 8px;
              background-color: #e6a23c;
              border-radius: 10px;
              font-size: 14px;
              margin-bottom: 12px;

              width: max-content;
              min-width: 100px;
            }

            .tdpp-line {
              width: 100%;
              height: 16px;
              position: relative;

              img {
                position: absolute;
                bottom: 40%;
              }

              .tdpp-progress-line {
                width: 100%;
                height: 100%;
                border-radius: 10px;
                background-image: linear-gradient(to right, #d4ecff, #6fbffe);
              }
            }

            .tdpp-line-num {
              position: relative;

              div {
                &:last-child {
                  position: absolute;
                  right: 0;
                }

                &.absoPosition {
                  position: absolute;
                }
              }
            }
          }

          .tdp-pro-unscramble {
            padding: 0 6px;
            margin-top: 18px;

            div {
              &:first-child {
                margin: 8px 0;
              }

              &:last-child {
                letter-spacing: 4px;
                line-height: 1.5;
              }
            }
          }
        }
      }

      .user-textarea-part {
        margin-top: 16px;

        .utp-title {
          margin-bottom: 8px;
        }

        .no-margin {
          margin: 0;
        }

        .doctor-input {
          width: 200px;
          margin-left: 14px;
        }
      }

      .input-hint {
        color: #ad373d;
        margin-left: 8px;
      }
    }
  }
}
</style>
